var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAcura(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_381",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28994",
    "data-name": "Group 28994",
    transform: "translate(-3820 5094)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 3820, -5094)",
    filter: "url(#Ellipse_381)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_381-2",
    "data-name": "Ellipse 381",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "icons8-acura",
    d: "M23.708,34.036c7.145-1.135,11.181-5.471,11.181-14.359S30.853,6.449,23.708,5.314A27.035,27.035,0,0,0,19.444,5a27.035,27.035,0,0,0-4.263.314C8.042,6.449,4,10.785,4,19.678S8.042,32.9,15.181,34.036a27.059,27.059,0,0,0,4.263.308A27.059,27.059,0,0,0,23.708,34.036Zm0-27.066c5.049,1.084,8.9,3.968,8.9,12.7,0,6.637-2.1,9.671-5.467,11.479L25.622,18.9,20.616,6.581A19.178,19.178,0,0,1,23.708,6.971Zm-5.036-.416c.2,0,.576-.01.772-.01s.576.005.772.01v10.8l-1.526.017ZM6.316,19.672c0-8.734,3.816-11.617,8.864-12.7a19.277,19.277,0,0,1,3.092-.391L13.267,18.9,11.753,31.151C8.388,29.343,6.316,26.309,6.316,19.672Zm8.865,12.707a13.493,13.493,0,0,1-3.1-1.053L18.672,18.9h1.544l6.589,12.426a13.493,13.493,0,0,1-3.1,1.053,21.805,21.805,0,0,1-8.527,0Z",
    transform: "translate(3837 -5080)",
    fill: "#455a64"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcura);
export default __webpack_public_path__ + "static/media/acura.9b00415a94e099da11040721e876f595.svg";
export { ForwardRef as ReactComponent };